<script setup lang="ts">
    import { computed, shallowReactive, onMounted, watch, ref } from 'vue'
    import { useRoute } from 'vue-router'
    import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue'
    import Navigation from '@common/Navigation.vue'
    import ProjectNavigation from '@Quest/ProjectPlans/Components/ProjectNavigation.vue'
    import ProjectContextHeader from '@Quest/ProjectPlans/Components/ProjectContextHeader.vue'
    import { useProjectPlanSummaryPageQueryV1 } from '@Quest/ProjectPlans/queries-vue-composables'
    import type { ProjectPlanSummaryPageReadModel } from '@Quest/ProjectPlans/readmodels'

    const route = useRoute()
    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const tchProjectId = computed(() => Number(route.params.tchProjectId ?? 0))
    const projectId = computed(() => String(route.params.projectId ?? ''))

    const rm = ref<ProjectPlanSummaryPageReadModel | null>(null)
    const projectPlanId = computed<string | null>(() => rm.value?.ProjectPlanId ?? null)

    const projectName = computed(() => rm.value?.ProjectName ?? '')
    const projectPlanName = computed<string>(() => rm.value?.ProjectPlanName ?? '')
    const activePlanId = computed<string | null>(() => rm.value?.ActiveProjectPlanId ?? null)

    const portfolioId = computed(() => rm.value?.PortfolioId ?? '')
    const userId = computed(() => rm.value?.UserId)
    const isWorkspaceMember = computed(() => rm.value?.IsWorkspaceMember ?? false)
    const isProjectOwner = computed(() => rm.value?.IsProjectOwner ?? false)

    const {
        runProjectPlanSummaryPageQueryV1,
        modelProjectPlanSummaryPageQueryV1
    } = useProjectPlanSummaryPageQueryV1(workspaceId, tchProjectId, projectId)
    

    onMounted(() =>
    {
        document.title = 'Project | TransparentChoice'
        runProjectPlanSummaryPageQueryV1()
    })

    watch(() => route.params.planId, () => 
    {
        runProjectPlanSummaryPageQueryV1({
            ProjectPlanId: route.params.planId as string | null
        })
    })

    watch(modelProjectPlanSummaryPageQueryV1, (current) =>
    {
        if (current?.RedirectUrl)
        {
            window.location.replace(current.RedirectUrl)
        }

        if (current)
        {
            rm.value = current
        }
    })


</script>

<template>
    <div>
        <PortfolioNavigation v-if="isWorkspaceMember" :workspaceId="workspaceId" :projectId="tchProjectId" />
        <Navigation v-else-if="isProjectOwner" />

        <div v-if="rm" class="container-fluid" style="margin-top: 80px; padding-top: 40px;">

            <div class="row">
                <div class="col-lg-6">
                    <ProjectContextHeader :projectName="projectName"
                                          :planId="projectPlanId"
                                          :planName="projectPlanName"
                                          :activePlanId="activePlanId" />
                </div>
                <div class="col-lg-6 text-right align-self-end">

                </div>
            </div>
            <hr />

            <div v-if="rm">

                <ProjectNavigation ActivePage="summary" class="mt-4 mb-4"
                                   :workspaceId="workspaceId"
                                   :tchProjectId="tchProjectId"
                                   :projectId="projectId"
                                   :planId="projectPlanId" />
            </div>
        </div>
    </div>
</template>
